import { MapView } from './mapView';
import { VehiclesController } from './../vehicles';
import { EventsController } from './../events';
import { BansController } from './../bans';

export class MapController {
  constructor(className, nodeRef) {
    this._mapView = new MapView(className);
    this._nodeRef = nodeRef;
    this._showCrush = false;
    this._heatMap = false;
    this._noTag = false;

    this._linkVehicles = null;
    this._vehicles = {};

    this._linkEvents = null;
    this._events = {};

    this._linkBans = null;
    this._bans = {};
    this._showBan = false;

    this._vehicleColor = '#44D7B6';

    this._mapView.map.on('zoom', this.zoomEventsUpdate.bind(this));
  }

  get showCrush() {
    return this._showCrush;
  }

  set showCrush(value) {
    return this._showCrush = value;
  }

  get heatMap() {
    return this._heatMap;
  }

  set heatMap(value) {
    return this._heatMap = value;
  }

  get noTag() {
    return this._noTag;
  }

  set noTag(value) {
    return this._noTag = value;
  }

  get showBan() {
    return this._showBan;
  }

  set showBan(value) {
    return this._showBan = value;
  }

  get nodeRef() {
    return this._nodeRef;
  }

  get vehicleColor() {
    return this._vehicleColor;
  }

  set vehicleColor(value) {
    this._vehicleColor = value;
  }

  linkVehicles(nodeRef) {
    this._linkVehicles = nodeRef.downlinkMap().laneUri('vehicles')
      .didUpdate(this.vehiclesData.bind(this))
      .open();
  }

  unlinkVehicles() {
    if(this._linkVehicles) {
      this._linkVehicles.close();
      this._linkVehicles = null;
    }
    for(const key in this._vehicles) {
      this._vehicles[key].remove();
    }
    this._vehicles = {};
  }

  vehiclesData(k, v) {
    const key = k.stringValue();
    let vehicle = this._vehicles[key];
    if(!vehicle) {
      vehicle = this._vehicles[key] = new VehiclesController(this, this._mapView, k, v);
    }

    if(v.toAny()) {
      vehicle.update(v);
    }
  }

  linkEvents() {
    this._linkEvents = this._nodeRef.downlinkMap().laneUri('geoFences')
      .didUpdate(this.eventsData.bind(this))
      .open();
  }

  unlinkEvents() {
    if(this._linkEvents) {
      this._linkEvents.close();
      this._linkEvents = null;
    }
    for(const key in this._events) {
      this._events[key].remove();
    }
    this._events = {};
  }

  eventsData(k, v) {
    const key = k.stringValue().replace(' ', '-').toLowerCase();
    let events = this._events[key];
    if(!events) {
      events = this._events[key] = new EventsController(this, this._mapView, key, v);
    }

    events.update(v);
  }

  linkBans() {
    this._linkBans = this._nodeRef.downlinkMap().laneUri('bans')
      .didUpdate(this.bansData.bind(this))
      .open();
  }

  unlinkBans() {
    if(this._linkBans) {
      this._linkBans.close();
      this._linkBans = null;
    }
    for(const key in this._bans) {
      this._bans[key].remove();
    }
    this._bans = {};
  }

  bansData(k, v) {
    const key = k.stringValue().replace(' ', '-').toLowerCase();
    let events = this._bans[key];
    if(!events) {
      events = this._bans[key] = new BansController(this, this._mapView, key, v);
    }

    events.update(v);
  }

  render() {
    this.renderChilds(this._vehicles);
    this.renderChilds(this._events);
    this.renderChilds(this._bans);
  }

  renderChilds(childsView) {
    for(const key in childsView) {
      const child = childsView[key];
      child.render();
    }
  }

  zoomEventsUpdate(event) {
    const zoomLevel = this._mapView.map.getZoom();
    for(const key in this._events) {
      const child = this._events[key];
      child.zoomUpdate(zoomLevel);
    }

    for(const key in this._bans) {
      const child = this._bans[key];
      child.zoomUpdate(zoomLevel);
    }
  }

}
